import MediaQuery from 'react-responsive';
import VideoIntersection from '../components/videoIntersection';
import Key5 from '../components/keys/key5';
import Key4Mobile from '../components/keys/key4mobile';
const makeItYoursVideo = '/ReactAssets/CustomerJourney/YOURS_MAIN.mp4';

function MakeItYours({ animate }) {
   return (
      <div className="flex makeityours">
         <div className="col-1/2 overflow-visible">
            <MediaQuery maxWidth={767}>
               <Key4Mobile animate={animate} />
            </MediaQuery>
            <MediaQuery minWidth={768}>
               <Key5 animate={animate} />
            </MediaQuery>
         </div>
         <div className="col-1/2">
            <VideoIntersection
               animate={animate}
               src={makeItYoursVideo}
               loop
               poster="/ReactAssets/CustomerJourney/house.png"
            />
            <div className="content">
               <h2>Make it yours</h2>
               <p>
               That’s the one, you found your dream home – whoop! 
               Now to make it official, by pre-reserving it easily online 
               or in our sales centre. You’ll pay a reservation fee, 
               and your new home will be taken off the market and the price frozen. Amazing!
               </p>
               <a
                  href="/what-makes-us-different/online-reservations.aspx"
                  class="btn btn-primary"
               >
                  Pre-reserve my home
               </a>
            </div>
         </div>
      </div>
   );
}

export default MakeItYours;
